export function useSketchColor(selItem,emits){

  const showSketch=ref(false);

  /**
   * 背景颜色
   */
  const sketchBgColor=ref('#333');

  /**
   * 显示颜色选择面板
   */
  const changSketch=function (){
    if(!unref(showSketch)){
      emits('closeOtherColor','')
    }
    nextTick(()=>{
      showSketch.value=!showSketch.value;
    })
  }

  /**
   * 颜色选择事件
   * @param item
   */
  const changSketchButton = (item) => {
    sketchBgColor.value = item.activeColor;
    selItem({id:item.activeColor});
  }

  const colors=ref("#Fff");

  watch(colors,(newVal:any)=>{
    changSketchButton({activeColor:newVal.hex});
  })

  /**
   * 关闭控件
   */
  const closePanel=function (){
    showSketch.value=false;
  }
  return {
    closePanel,
    changSketch,
    sketchBgColor,
    changSketchButton,
    colors,
    showSketch
  }
}
